import enabledColumns from './enabled_columns'

export default function reducer (state = {}, action) {
  return {
    enabledColumns: enabledColumns(state.enabledColumns, action)
  }
}
